import { Edit, Move, Options, Settings } from '@morph-mapper/ui';
import { StyledActionCell, StyledObjectRow } from './styles';
import {
  Group,
  Tooltip,
  useMantineTheme,
  Badge,
  Menu,
  Box,
  Portal,
} from '@mantine/core';
import { useMapRow } from './use-map-row';
import { useMapEntryContext } from '../../context';
import { useStore } from '@/store';
import { useStructureBlocks } from '@morph-mapper/node-logic';
import { IoMdRadioButtonOff, IoMdRadioButtonOn } from 'react-icons/io';

export const MapRow = () => {
  const variant = useStore(({ config: c }) => c.getVariant());
  const [name, outputType, setOutputType] = useMapEntryContext((s) => [
    s.getName(),
    s.getOutputType(),
    s.setOutputType,
  ]);
  const { handleTypeChange, handleConfigureEntry, handleFocusChange } =
    useMapRow();
  const { structureBlocks } = useStructureBlocks(variant);
  const theme = useMantineTheme();

  return (
    <StyledObjectRow>
      <td>{name}</td>
      <td>
        <Tooltip label={structureBlocks[outputType].description}>
          <Badge color="cyan" radius="xs" variant="outline" sx={{ opacity: 1 }}>
            {structureBlocks[outputType].title}
          </Badge>
        </Tooltip>
      </td>
      <td>
        <StyledActionCell>
          <Group>
            {structureBlocks[outputType].type !== 'code' ? (
              <Settings onClick={handleConfigureEntry} />
            ) : (
              <Edit onClick={handleConfigureEntry}></Edit>
            )}
            <Move
              disabled={structureBlocks[outputType].type === 'code'}
              onClick={handleFocusChange}
            />
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Menu shadow="md" width={150} position="bottom-end">
                <Menu.Target>
                  <Options />
                </Menu.Target>
                <Portal>
                  <Menu.Dropdown sx={{ zIndex: 1000 }}>
                    <Menu.Label>Type</Menu.Label>
                    <Menu.Item
                      icon={
                        structureBlocks[outputType].type !== 'code' ? (
                          <IoMdRadioButtonOn color={theme.colors.blue[7]} />
                        ) : (
                          <IoMdRadioButtonOff color={theme.colors.gray[6]} />
                        )
                      }
                      onClick={() => handleTypeChange(false)}
                    >
                      Map
                    </Menu.Item>
                    <Menu.Item
                      icon={
                        structureBlocks[outputType].type === 'code' ? (
                          <IoMdRadioButtonOn color={theme.colors.blue[7]} />
                        ) : (
                          <IoMdRadioButtonOff color={theme.colors.gray[6]} />
                        )
                      }
                      onClick={() => handleTypeChange(true)}
                    >
                      Code
                    </Menu.Item>
                  </Menu.Dropdown>
                </Portal>
              </Menu>
            </Box>
          </Group>
        </StyledActionCell>
      </td>
    </StyledObjectRow>
  );
};
